// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1XfEU","requiredAsterisk":"Info_requiredAsterisk__l9CYZ"};